import { isDefined } from '@zorro/common-utils';
import { formatCurrencyEnUs } from '@zorro/shared/formatters';
import { Group, Text } from '@zorro/web/design-system';

type Props = {
  minimumStipend?: number;
  maximumStipend?: number;
};

export const PersonalizedAllowanceAmountTooltip = ({
  minimumStipend,
  maximumStipend,
}: Props) => {
  const rangeStipends =
    isDefined(minimumStipend) &&
    isDefined(maximumStipend) &&
    minimumStipend !== maximumStipend;
  if (rangeStipends) {
    return (
      <Group wrap="nowrap" gap={2}>
        <Text fz="xs">
          {formatCurrencyEnUs(minimumStipend, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </Text>

        <Text fz="xs">-</Text>

        <Text fz="xs">
          {formatCurrencyEnUs(maximumStipend, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </Text>
      </Group>
    );
  }
  const stipend = minimumStipend ?? maximumStipend;
  return (
    <Group wrap="nowrap" gap={2}>
      {isDefined(stipend) && (
        <Text fz="xs">
          {formatCurrencyEnUs(stipend, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </Text>
      )}
    </Group>
  );
};
